<template>
  <!-- <div class="w-full h-full grid grid-rows-[auto_1fr] overflow-hidden"> -->
  <VanPopup
    v-model:show="globalModal.showMiniProgramModal"
    position="bottom"
    class="w-full h-full"
    safe-area-inset-top
  >
    <div class="w-full h-full">
      <div class="absolute top-3 right-2">
        <div
          class="flex items-center gap-4 bg-white rounded-full px-4 pt-2 pb-1"
        >
          <!-- <div class="cursor-pointer" @click="shareRoom">
            <i class="iconify mdi--share-variant-outline text-black"></i>
          </div> -->

          <!-- <div class="flex items-center gap-1 cursor-pointer">
          <i class="iconify mdi--account-group-outline text-black"></i>
          <div class="bg-red-500 text-white text-sm px-2 rounded-full">99+</div>
        </div> -->
          <div class="cursor-pointer" @click="goBack">
            <i class="iconify mdi--close-circle-outline text-black"></i>
          </div>
        </div>
      </div>
      <iframe
        v-if="globalModal.miniProgramUrl"
        :src="globalModal.miniProgramUrl"
        frameborder="0"
        class="w-full h-full"
      />
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { copyToClipboard } from "@/modules/common";
import { showSuccessToast } from "vant";
import { useI18n } from "vue-i18n";
import { useGlobalModal } from "@/stores/globalModal";
const { t } = useI18n();
const globalModal = useGlobalModal();

const goBack = () => {
  globalModal.miniProgramUrl = "";
  globalModal.showMiniProgramModal = false;
};

const shareRoom = () => {
  const { origin } = window.location;
  copyToClipboard(
    `${origin}/?mini_program_url=${encodeURIComponent(
      globalModal.miniProgramUrl
    )}`
  );
  showSuccessToast(t("Message.copySuccessful"));
};
</script>

<style scoped>
.status-1,
.status-2 {
  background: #fed500;
}

.status-3 {
  background: #00fe43;
}
</style>
